export default "__VITE_ASSET__BcnpI$BR__"